exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-btn-store-add[data-v-44b587dc] {\n  color: #ff6c00;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 1.4rem;\n  white-space: nowrap;\n}\n.c-btn-store-add[data-v-44b587dc]:hover {\n  text-decoration: none;\n}\n", ""]);

// exports
